module.exports = __webpack_public_path__ + "img/SC2-about.8c5cbdcb.png";